import { forwardRef, type SVGProps } from 'react';

/**
 * SensorInfoIconDisabled component
 *
 * @param props - SVG props
 */
const SensorInfoIconDisabled = forwardRef<
  SVGSVGElement,
  SVGProps<SVGSVGElement>
>((props, ref) => (
  <svg
    ref={ref}
    width={20}
    height={21}
    viewBox='0 0 20 21'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <mask
      id='path-1-outside-1_14280_34957'
      maskUnits='userSpaceOnUse'
      x={0}
      y={0}
      width={20}
      height={21}
      fill='black'
    >
      <rect fill='white' width={20} height={21} />
      <path d='M0 0H20V20H0V0Z' />
    </mask>
    <path
      d='M0 20V20.5H0.5V20V19.5H0V20ZM1.5 20V20.5H2.5V20V19.5H1.5V20ZM3.5 20V20.5H4.5V20V19.5H3.5V20ZM5.5 20V20.5H6.5V20V19.5H5.5V20ZM7.5 20V20.5H8.5V20V19.5H7.5V20ZM9.5 20V20.5H10.5V20V19.5H9.5V20ZM11.5 20V20.5H12.5V20V19.5H11.5V20ZM13.5 20V20.5H14.5V20V19.5H13.5V20ZM15.5 20V20.5H16.5V20V19.5H15.5V20ZM17.5 20V20.5H18.5V20V19.5H17.5V20ZM19.5 20V20.5H20V20V19.5H19.5V20ZM0 20V21H0.5V20V19H0V20ZM1.5 20V21H2.5V20V19H1.5V20ZM3.5 20V21H4.5V20V19H3.5V20ZM5.5 20V21H6.5V20V19H5.5V20ZM7.5 20V21H8.5V20V19H7.5V20ZM9.5 20V21H10.5V20V19H9.5V20ZM11.5 20V21H12.5V20V19H11.5V20ZM13.5 20V21H14.5V20V19H13.5V20ZM15.5 20V21H16.5V20V19H15.5V20ZM17.5 20V21H18.5V20V19H17.5V20ZM19.5 20V21H20V20V19H19.5V20Z'
      fill='currentColor'
      mask='url(#path-1-outside-1_14280_34957)'
    />
    <path
      d='M7.03748 8.54582C6.96248 8.82082 6.92081 9.11248 6.92081 9.41248C6.92081 10.3292 7.29581 11.1625 7.89581 11.7708L6.71248 12.9542C5.81248 12.0458 5.25414 10.7958 5.25414 9.41248C5.25414 8.63748 5.42914 7.91248 5.73748 7.25415L4.51248 6.02915C3.92081 7.02082 3.58748 8.17915 3.58748 9.41248C3.58748 11.2542 4.33748 12.9208 5.54581 14.1208L4.36248 15.3042C2.85414 13.7958 1.92081 11.7125 1.92081 9.41248C1.92081 7.71248 2.42914 6.13748 3.30414 4.82082L1.41248 2.92915L2.58748 1.75415L17.9041 17.0708L16.7291 18.2458L7.03748 8.54582ZM14.7708 11.5708C15.0791 10.9125 15.2541 10.1875 15.2541 9.41248C15.2541 8.02915 14.6958 6.77915 13.7875 5.87915L12.6041 7.06248C13.2125 7.66248 13.5875 8.49582 13.5875 9.41248C13.5875 9.71248 13.5458 10.0042 13.4708 10.2792L14.7708 11.5708ZM16.9208 9.41248C16.9208 10.6458 16.5875 11.8042 15.9958 12.7958L17.2041 14.0042C18.0791 12.6875 18.5875 11.1125 18.5875 9.41248C18.5875 7.11248 17.6541 5.02915 16.1458 3.52082L14.9625 4.70415C16.1708 5.90415 16.9208 7.57082 16.9208 9.41248Z'
      fill='currentColor'
    />
  </svg>
));

SensorInfoIconDisabled.displayName = 'SensorInfoIconDisabled';

export default SensorInfoIconDisabled;
